import { useState } from "react";
import { useAuth } from "react-oidc-context";

export const useCreateGreenMilesHotel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const auth = useAuth();

  const createHotel = async (hotelData) => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const apiUrl = process.env.REACT_APP_API_URL || "/api";

      const response = await fetch(`${apiUrl}/greenmiles/demos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth.user.access_token}`,
        },
        body: JSON.stringify(hotelData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erreur lors de la création de l'hôtel");
      }

      if (data.success === "ERROR") {
        throw new Error(data.message || "Erreur lors de la création de l'hôtel");
      }

      setSuccess(true);
      return {
        success: true,
        data: data.result,
        message: data.message,
      };
    } catch (err) {
      console.error("Erreur lors de la création de l'hôtel GreenMiles:", err);
      setError(err.message);
      return {
        success: false,
        error: err.message,
      };
    } finally {
      setIsLoading(false);
    }
  };

  const resetState = () => {
    setError(null);
    setSuccess(false);
    setIsLoading(false);
  };

  return {
    createHotel,
    isLoading,
    error,
    success,
    resetState,
  };
};
